<div>
  <div class="table-responsive mt-2">
    <table class="table">
      <thead>
        <tr>
          <th>SrNo</th>
          <th>Survey Name</th>
          <th>Dealer LoginName</th>
          <th>Dealer Shop Name</th>
        </tr>
      </thead>
      <tbody>
        @for (data of dealerSurveyList
        | paginate: { itemsPerPage: pageSize, currentPage: page + 1, totalItems: allTotal};
        track data.srNo; let i = $index) {
        <tr (dblclick)="goToSurveyInfo(data.surveyId, data.dealerLoginName)">
          <td>{{data.srNo}}</td>
          <td>{{data.surveyName}}</td>
          <td>{{data.dealerLoginName}}</td>
          <td>{{data.dealerShopName}}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <footer>
    <div class="text-center">
      <pagination-controls [maxSize]="20" previousLabel="Prev" nextLabel="Next" [responsive]="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </div>
  </footer>

  @if (loading) {
  <div class="d-flex flex-column justify-content-center align-items-center py-5">
    <div class="spinner-border text-primary mb-2" role="status"></div>
    <span class="text-muted">Loading data...</span>
  </div>
  }
</div>
